import { render, staticRenderFns } from "./TransactionMatchingConfig.vue?vue&type=template&id=b047634e&scoped=true"
import script from "./TransactionMatchingConfig.vue?vue&type=script&lang=js"
export * from "./TransactionMatchingConfig.vue?vue&type=script&lang=js"
import style0 from "./TransactionMatchingConfig.vue?vue&type=style&index=0&id=b047634e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b047634e",
  null
  
)

export default component.exports